var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_705",
    "data-name": "Group 705",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.219,
    height: 40.25,
    viewBox: "0 0 35.219 40.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3220",
    "data-name": "Path 3220",
    d: "M21.845,0H43.219L54.548,11.285V37.735a2.516,2.516,0,0,1-2.516,2.516H21.845a2.516,2.516,0,0,1-2.516-2.516V2.516A2.516,2.516,0,0,1,21.845,0Z",
    transform: "translate(-19.329)",
    fill: "#e2574c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3221",
    "data-name": "Path 3221",
    d: "M214.241,11.488h-8.768a2.516,2.516,0,0,1-2.516-2.516V.193Z",
    transform: "translate(-179.058 -0.168)",
    fill: "#b53629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3222",
    "data-name": "Path 3222",
    d: "M104.043,136.868a.731.731,0,0,0,0-1.448h-2.4a.75.75,0,0,0-.731.818v5.9c0,.526.3.818.7.818s.7-.292.7-.818v-1.619h1.452a.681.681,0,0,0,.675-.735.669.669,0,0,0-.675-.715H102.32v-2.2Zm-8.112-1.448H94.176a.777.777,0,0,0-.815.813v5.908a.774.774,0,0,0,.835.791h1.843a3.418,3.418,0,0,0,3.621-3.65A3.507,3.507,0,0,0,95.932,135.42Zm.084,6.055h-1.07v-4.6h.965c1.46,0,2.1.98,2.1,2.332C98.006,140.474,97.382,141.475,96.016,141.475Zm-6.433-6.055h-1.74a.732.732,0,0,0-.766.818v5.9a.741.741,0,1,0,1.474,0v-1.722h1.09a2.382,2.382,0,0,0,2.457-2.487A2.409,2.409,0,0,0,89.584,135.42Zm-.029,3.61h-1V136.8h1a1.118,1.118,0,0,1,0,2.225Z",
    transform: "translate(-78.261 -117.796)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.905d05b1749acbed96a163f880ac3089.svg";
export { ForwardRef as ReactComponent };